import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'


export const addFailSlice = createSlice({
  name: 'addFail',
  initialState: {
    modalbeforeSuccess:false,
    modalNote:false,
    loading:false,
    noteTXT:[],
   
  },
  reducers: {
    
      setModalBeforeSuccessRedux: (state, action) => {
        const { modalbeforeSuccess } = action.payload
        state.modalbeforeSuccess = modalbeforeSuccess
      },
      setModalNoteRedux: (state, action) => {
        const { modalNote } = action.payload
        state.modalNote = modalNote
      },
      setLoadingRedux: (state, action) => {
        const { loading } = action.payload
        state.loading = loading
      },
      setNoteTXTRedux: (state, action) => {
        const { noteTXT } = action.payload
        state.noteTXT = noteTXT
      },
      
  },
})

export default addFailSlice.reducer;

export const {
    setModalBeforeSuccessRedux,
    setModalNoteRedux,
    setLoadingRedux,
    setNoteTXTRedux
  
} = addFailSlice.actions

export const getModalBeforeSuccessRedux = (state) => state.addFail.modalbeforeSuccess
export const getModalNoteRedux = (state) => state.addFail.modalNote
export const getLoadingRedux = (state) => state.addFail.loading
export const getNoteTXTRedux = (state) => state.addFail.noteTXT



